import React from 'react';
import styled from 'styled-components/macro';
import useLocalize from '../Hooks/useLocalize';
import { Text } from '../SubComponents/Text';

const StyledFooter = styled.div<{ isOpen: boolean }>`
  width: calc(100% - 32px);
  border-top: 1px solid ${(props) => props.theme.colors.footer.borderColor};
  display: flex;
  gap: 32px;
  justify-content: center;
  align-items: center;
  padding: 16px;
  margin: 0 auto;
  background-color: #f5f5f5;
  max-width: 1120px;
  align-self: center;

  filter: ${(props) => (props.isOpen ? 'blur(2px)' : null)};
  transition: all 0.3s;

  @media screen and (max-width: 767px) {
    /* The mobile summery card is 50px high when collapsed */
    margin-bottom: 50px;
    flex-direction: column-reverse;
    gap: 16px;
    text-align: center;
    width: 90%;
  }
`;

const CookieButton = styled.button`
  width: fit-content;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  font-family: ${(props) => props.theme.fontText};
  font-size: 1.4rem;
  line-height: normal;
  color: ${(props) => props.theme.textColor};
`;

const Footer = ({ isOpen }: { isOpen: boolean }) => {
  const localize = useLocalize();

  return (
    <StyledFooter isOpen={isOpen}>
      <Text>
        {`Copyright © ${new Date().getFullYear()} GoBoat. ${localize(
          'product.allRightsReserved'
        )}`}
      </Text>
      <CookieButton data-legalmonster="show-cookie-settings">
        {localize('product.cookieSettings')}
      </CookieButton>
    </StyledFooter>
  );
};

export default Footer;
